(function () {
    function normalizeLetter(value) {
        var first = (value || '').trim().charAt(0);
        return /[\u0600-\u06FF]/.test(first)
            ? first
            : first.toLocaleUpperCase();
    }

    function englishToArabicLetter(letter) {
        var map = {
            A: 'ا',
            B: 'ب',
            C: 'ك',
            D: 'د',
            E: 'ا',
            F: 'ف',
            G: 'ج',
            H: 'ه',
            I: 'ا',
            J: 'ج',
            K: 'ك',
            L: 'ل',
            M: 'م',
            N: 'ن',
            O: 'ا',
            P: 'ب',
            Q: 'ق',
            R: 'ر',
            S: 'س',
            T: 'ت',
            U: 'و',
            V: 'ف',
            W: 'و',
            X: 'ا',
            Y: 'ي',
            Z: 'ز'
        };

        return map[letter.toUpperCase()] || letter;
    }

    function isArabic() {
        return document.documentElement.lang.startsWith('ar');
    }

    function initAllBrands(section) {
        if (section.dataset.initialized === 'true') {
            return;
        }

        section.dataset.initialized = 'true';

        var grid = section.querySelector('[data-brands-grid]');
        var buttons = section.querySelectorAll('[data-brand-filter]');
        var titleText = section.querySelector('[data-brands-title-text]');
        var countText = section.querySelector('[data-brands-count]');

        if (!grid || !buttons.length) {
            return;
        }

        var arabic = isArabic();
        var brandsSuffix = arabic ? ' ماركات' : ' Brands';

        var cards = Array.from(grid.querySelectorAll('[data-brand-card]'));

        cards
            .sort(function (a, b) {
                return (a.dataset.brandName || '').localeCompare(
                    b.dataset.brandName || '',
                    document.documentElement.lang,
                    {
                        sensitivity: 'base'
                    }
                );
            })
            .forEach(function (card) {
                grid.appendChild(card);
            });

        function setActive(button) {
            buttons.forEach(function (item) {
                var active = item === button;
                item.classList.toggle('is-active', active);
                item.setAttribute('aria-pressed', active ? 'true' : 'false');
            });
        }

        function updateTitle(label, visibleCount, totalCount) {
            if (titleText) {
                titleText.textContent = label || 'All Brands';
            }

            if (countText) {
                countText.textContent = '(' + (visibleCount || totalCount || 0) + ')';
            }
        }

        function filterCards(button) {
            var selectedLetter = button.dataset.brandFilter;
            var label = button.dataset.brandLabel || button.textContent.trim();

            var visibleCount = 0;

            cards.forEach(function (card) {

                var brandLetter =
                    card.dataset.brandLetter ||
                    normalizeLetter(card.dataset.brandName);

                // Convert English first letter to Arabic when store is Arabic
                if (arabic) {
                    brandLetter = englishToArabicLetter(brandLetter);
                }

                var shouldShow =
                    selectedLetter === 'all' ||
                    brandLetter === selectedLetter;

                card.hidden = !shouldShow;

                if (shouldShow) {
                    visibleCount++;
                }
            });

            setActive(button);

            updateTitle(
                selectedLetter === 'all'
                    ? (arabic ? 'كل الماركات' : 'All Brands')
                    : label + brandsSuffix,
                visibleCount,
                cards.length
            );
        }

        buttons.forEach(function (button) {
            button.addEventListener('click', function () {
                filterCards(button);
            });
        });

        var initialButton =
            section.querySelector('[data-brand-filter="all"]') || buttons[0];

        filterCards(initialButton);
    }

    function initSections(root) {
        (root || document)
            .querySelectorAll('[data-metaobject-all-brands]')
            .forEach(initAllBrands);
    }

    document.addEventListener('DOMContentLoaded', function () {
        initSections(document);
    });

    document.addEventListener('shopify:section:load', function (event) {
        event.target
            .querySelectorAll('[data-metaobject-all-brands]')
            .forEach(function (section) {
                delete section.dataset.initialized;
            });

        initSections(event.target);
    });
})();